/**
 * Created by aaikepae on 1/23/17.
 */


import React from "react"
import DOMPurify from "dompurify";
import {loadJSFiles, executeHTMLScript, updateRelatedLink, removeVideoAutoPlay} from "../../../../common/utility/utils";
import {smoothScroll} from "../../../../common/utility/dom";

import Footer from "../Foorter";

class SafeHtmlPreview extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    if (this.containerRef.current) {
      this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.html !== this.props.html && this.containerRef.current) {
      this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }

  render() {
    return <div className={this.props.className} ref={this.containerRef}/>;
  }
}

export default class extends React.Component {


  // get absolute URI path of current content
  get contentURLPath() {
    const {config, selected} = this.props;
    if (config && config.location && selected && selected.item) {
      const contentPath = selected.item.content;
      return config.location + contentPath.substr(0, contentPath.lastIndexOf("/") + 1);
    }
  }

  // find pubhub instance's container

  get container() {
    if (this.docRef && this.docRef.current) {
      const docEL = this.docRef.current;
      return Array.from(document.querySelectorAll(".pubhub-container")).find(function (el) {
        return el.contains(docEL)
      });
    }
  }

  constructor(props) {
    super(props);
    this.docRef = React.createRef();
  }


  componentDidMount() {
    const self = this;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = this.props.data;


    //
    updateRelatedLink(wrapper, this.contentURLPath, this.props.config.location);
    removeVideoAutoPlay(wrapper);

    loadJSFiles(wrapper, this.contentURLPath, function () {
      self.html = wrapper.innerHTML;
      self.forceUpdate();
      setTimeout(executeHTMLScript(self.refs["doc"]), 0)
    });

    this.scrollToTop();
  }

  scrollToTop() {
    const _scroll_offset_top = document.querySelector(".pubhub-doc-container").offsetTop;
    const scrollingContainer = document.scrollingElement || document.documentElement;
    smoothScroll(scrollingContainer, _scroll_offset_top - 10, 400)
  }

  render() {
    const {config, selected} = this.props;

    if (this.props.data && this.html) {

      const contentClass = ["column-doc", selected.item.type, config.layout].join(" ");

      return (
        <div className={contentClass} ref={this.docRef}>
          <SafeHtmlPreview className="pb-doc-content" html={this.html}/>
          <Footer router={this.props.router} config={this.props.config} selected={this.props.selected}/>
        </div>
      )
    } else {
      return <div/>
    }
  }


}

